import { submitRiskDeclaration } from "api/childAccount/request";
import { IError } from "api/types";
import Button from "components/InvestorCommon/Button/Button";
import CheckBox from "components/InvestorCommon/CheckBoxV2/CheckBox";
import CommonModal from "components/InvestorCommon/ModalV2/CommonModal";
import { Title } from "components/InvestorCommon/TextV2";
import { useState } from "react";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { RiskDeclaration } from "state/riskDeclaration";

const COMPLIANCE_TEXT =
	"We confirm that all investor accounts satisfy and comply with all onboarding requirements, " +
	"KYC/AML checks and eligibility criteria as required by us and under applicable laws and " +
	"regulations, and that we maintain and retain all relevant records evidencing such compliance.";

const SUITABILITY_TEXT =
	"We confirm that we have conducted appropriate risk suitability assessments for all investors " +
	"accounts in accordance with applicable laws and regulations and that each investor account is " +
	"suitable for the products transacted through the KLDX Platform";

const InvestorRiskDeclarationModal = () => {
	const { isOpen, close, markSubmitted } = RiskDeclaration.useContainer();
	const [compliance, setCompliance] = useState(false);
	const [suitability, setSuitability] = useState(false);

	const [submit, { status }] = useMutation(submitRiskDeclaration, {
		onSuccess: async () => {
			await markSubmitted();
			setCompliance(false);
			setSuitability(false);
		},
		onError: (error: IError) => {
			const message = Array.isArray(error?.message) ? error?.message?.[0] : error?.message;
			toast.error(message || "Something went wrong. Please try again.");
		},
	});

	if (!isOpen) return null;

	const isLoading = status === "loading";
	const canSubmit = compliance && suitability && !isLoading;

	const handleCancel = () => {
		if (isLoading) return;
		setCompliance(false);
		setSuitability(false);
		close();
	};

	const handleSubmit = () => {
		if (!canSubmit) return;
		submit({ isInvestorComplianceConfirmed: true, isInvestorSuitabilityConfirmed: true });
	};

	const content = (
		<div className="flex w-full flex-col">
			<Title level={4} weight={700} className="mb-8 justify-center text-center">
				Investor Risk Declaration
			</Title>
			<div className="flex flex-col gap-6">
				<CheckBox
					description={COMPLIANCE_TEXT}
					onClick={(e: any) => setCompliance(!!e?.target?.checked)}
				/>
				<CheckBox
					description={SUITABILITY_TEXT}
					onClick={(e: any) => setSuitability(!!e?.target?.checked)}
				/>
			</div>
			<div className="mt-10 flex flex-col items-center justify-end gap-4 sm:flex-row">
				<Button
					theme="primary"
					width="180px"
					loading={false}
					disabled={isLoading}
					onClick={handleCancel}
				>
					Cancel
				</Button>
				<Button
					theme="secondary"
					width="220px"
					loading={isLoading}
					disabled={!canSubmit}
					onClick={handleSubmit}
				>
					Confirm &amp; Submit
				</Button>
			</div>
		</div>
	);

	return (
		<CommonModal
			content={content}
			onClickExit={handleCancel}
			className="fixed inset-0 flex items-center justify-center -translate-y-40"
		/>
	);
};

export default InvestorRiskDeclarationModal;
